<div
  class="col-12 d-flex align-items-center justify-content-between ps-3 pe-5 my-3"
>
  <div class="sidebar-logo-sidac">
    <a href="/" target="_self">
      <img class="pt-0 pb-3" src="./assets/image/logo-cnseg.png" alt="logo" />
    </a>
  </div>

  @if (isLoggedIn$ | async) {

  <div class="d-flex align-items-center justify-content-end">
    <button
      nz-button
      nzType="default"
      nzShape="circle"
      class="button-container border-0 bg-transparent shadow-none mx-2"
      nz-popover
      nzPopoverContent="Tempo de sessão"
      nzPopoverPlacement="bottom"
      (click)="resetTempoSessao()"
    >
      <div class="content">
        <i class="fi fi-rr-time-forward fs-5"></i>
        <span>{{ tempoSessao }}</span>
      </div>
    </button>

    <button
      nz-button
      nzType="default"
      nzShape="circle"
      class="button-container border-0 bg-transparent shadow-none mx-2"
      nz-popover
      nzPopoverContent="Ajuda"
      nzPopoverPlacement="bottom"
      (click)="faq()"
    >
      <div class="content">
        <i class="fi fi-rr-comment-question fs-5"></i>
      </div>
    </button>

    <button
      nz-button
      nzType="default"
      nzShape="circle"
      class="button-container border-0 bg-transparent shadow-none mx-2"
      nz-popover
      nzPopoverContent="Notificações"
      nzPopoverPlacement="bottom"
    >
      <div class="content">
        <i class="fi fi-rs-bell fs-5"></i>
      </div>
    </button>

    <div class="user px-3">
      <ul>
        <li>{{ headerPageSignalDataService.nameUser$() }}</li>
        <li class="text-capitalize">
          Usuário - {{ headerPageSignalDataService.profileUser$() }}
        </li>
      </ul>
    </div>

    <div class="dropdown-user">
      <a
        nz-dropdown
        nz-popover
        [nzPopoverContent]="contentTemplate"
        nzPopoverPlacement="bottomRight"
      >
        <i class="fi fi-rs-smile-wink fs-4 pe-2"></i>
        <i class="fi fi-rr-angle-small-down fs-5"></i>
      </a>
      <ng-template #contentTemplate>
        <ul class="m-0 p-0">
          <li>
            <a nz-button nzType="link" (click)="logout()">Sair</a>
          </li>
        </ul>
      </ng-template>
    </div>
    <!-- <div class="d-flex align-items-center ms-5">
      <div class="sidebar-logo">
        <a href="/" target="_self">
          <img
            class="pt-0 pb-3"
            src="./assets/image/FundoLogin.png"
            alt="logo cnseg"
          />
        </a>
      </div>
    </div>-->
  </div>
  }
</div>
